import * as React from 'react';
import { compose, defaultProps, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { FontIcon } from '../../FontIcon';
import { toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    root: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flex: 1,
        width: '100%',
        height: '100%',
    },
    placeholderIcon: {
        maxHeight: 120,
    },
    smallPlaceholderIcon: {
        maxHeight: 95,
    },
    title: {
        color: theme.color.grey.dark,
        fontSize: theme.font.size.title,
        lineHeight: theme.font.lineHeight.medium,
        fontWeight: theme.font.weight.bold,
        margin: '0.65em auto',
        display: 'block',
    },
    description: {
        color: theme.color.grey.dark,
        maxWidth: 370,
        fontSize: '0.95em',
        padding: toCssValue([0, theme.space.padding.default]),
        lineHeight: theme.font.lineHeight.mediumBig,
        margin: '0 auto 2em auto',
        display: 'block',
        '&:first-letter': {
            textTransform: 'uppercase',
        },
    },
    smallTitle: {
        fontSize: theme.font.size.mediumBig,
        textTransform: 'none',
        marginTop: theme.space.margin.smallest,
        marginBottom: theme.space.margin.small,
        fontWeight: theme.font.weight.bold,
        lineHeight: theme.font.lineHeight.medium,
    },
    smallDescription: {
        fontSize: theme.font.size.medium,
        lineHeight: 1.4,
    },
});
const Placeholder = (props) => {
    const { classes, title, description, className: classNameProp, iconName, small, children, iconFromMui, testId = 'Placeholder', } = props;
    const className = classNames(classes.root, classNameProp);
    const iconEl = iconName && (React.createElement(FontIcon, { fromMui: iconFromMui, iconName: iconName, color: '#4a4a4a', className: classNames(small ? classes.smallPlaceholderIcon : classes.placeholderIcon), size: small ? 80 : 100 }));
    return (React.createElement("div", { className: className, "data-testid": `${testId}` },
        React.createElement("div", null,
            iconEl,
            React.createElement("span", { "data-testid": `${testId}-title`, className: classNames(classes.title, small ? classes.smallTitle : null) }, title),
            React.createElement("span", { "data-testid": `${testId}-description`, className: classNames(classes.description, small ? classes.smallDescription : null) }, description),
            children)));
};
const ComposedPlaceholder = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    title: '',
    description: '',
}))(Placeholder);
ComposedPlaceholder.displayName = 'Placeholder';
export default ComposedPlaceholder;
//# sourceMappingURL=Placeholder.js.map